<template>
	<SectionCard>
		<template #title>
			Properties
		</template>
		<template #body>
			<v-row dense>
				<v-col cols="6">
					<TextField
						:value="sourceResponse.sourceCode"
						label="Source Code"
						maxlength="50"
						counter="50"
						:disabled="!userFullPermissions"
						tooltip-text="<p>Input your Source Code text if required</p><p>This data will be stored against the Preference update for the Data Subject in question and can be used to record the source of the transaction where the widget is used</p>"
						@input="updateSourceResponse('sourceCode', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="6">
					<TextField
						:value="sourceResponse.responseChannel"
						label="Response Channel"
						maxlength="50"
						counter="50"
						:disabled="!userFullPermissions"
						tooltip-text="<p>Input your Response Channel text if required</p><p>This data will be stored against the Preference update for the Data Subject in question and can be used to record the source of the transaction where the widget is used</p>"
						@input="updateSourceResponse('responseChannel', $event)"
					/>
				</v-col>
			</v-row>
		</template>
	</SectionCard>
</template>

<script>
import SectionCard from '../../../../../../shared/components/section-card.vue'
import TextField from '../../../../../../shared/components/text-field.vue'

export default {
	components: {
		SectionCard,
		TextField
	},
	props: {
		sourceResponse: {
			type: Object,
			required: true
		},
		userFullPermissions: Boolean
	},
	methods: {
		updateSourceResponse (key, value) {
			this.$emit('update-source-response', key, value)
		}
	}
}
</script>
